@if (auction.whatToShow.includes('1') || auction.whatToShow.includes('7') || auction.whatToShow.includes('4') || auction.whatToShow.includes('9') || auction.whatToShow.includes('11')) {
  Bidding
}
@if (auction.whatToShow.includes('A')) {
  Bidding Starts Soon!
}
@if (auction.whatToShow.includes('B')) {
  <ng-container class="tiles-bidding-soon">
    Bidding Is Open!
  </ng-container>
}
@if (auction.whatToShow.includes('12')) {
  Bidding Has Ended!
}
@if (auction.whatToShow.includes('C')) {
  @if (auction.currentAuction.ConflictCount > 0) {
    <ng-container class="tiles-bidding-conflict">
      Bidding: Conflicts!
    </ng-container>
  }
  @if (auction.currentAuction.ConflictCount <= 0) {
    Bidding: No Conflicts!
  }
}
